import { useLang } from "../../site-context";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div className="relative overflow-hidden border-y border-[#e3a008]/15 bg-[#0d1830] py-5" data-testid="marquee-strip">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="ff-display px-8 text-xl italic text-slate-300 sm:text-2xl">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#e3a008]" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
